var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 17V13C4 12.5875 4.14694 12.2344 4.44083 11.9406C4.73472 11.6469 5.08806 11.5 5.50083 11.5H14.5058C14.9186 11.5 15.2708 11.6469 15.5625 11.9406C15.8542 12.2344 16 12.5875 16 13V17H4ZM7.74479 10.5C6.7066 10.5 5.82292 10.134 5.09375 9.40188C4.36458 8.66979 4 7.78437 4 6.74562C4 5.70687 4.36583 4.82292 5.0975 4.09375C5.82931 3.36458 6.71424 3 7.75229 3H12.2552C13.2934 3 14.1771 3.36604 14.9063 4.09813C15.6354 4.83021 16 5.71563 16 6.75438C16 7.79313 15.6342 8.67708 14.9025 9.40625C14.1707 10.1354 13.2858 10.5 12.2477 10.5H7.74479ZM5.5 15.5H14.5V13H5.5V15.5ZM7.75 9H12.25C12.875 9 13.4063 8.78125 13.8438 8.34375C14.2813 7.90625 14.5 7.375 14.5 6.75C14.5 6.125 14.2813 5.59375 13.8438 5.15625C13.4063 4.71875 12.875 4.5 12.25 4.5H7.75C7.125 4.5 6.59375 4.71875 6.15625 5.15625C5.71875 5.59375 5.5 6.125 5.5 6.75C5.5 7.375 5.71875 7.90625 6.15625 8.34375C6.59375 8.78125 7.125 9 7.75 9ZM8.28125 7.28563C8.42708 7.14271 8.5 6.96563 8.5 6.75438C8.5 6.54313 8.42854 6.36458 8.28562 6.21875C8.14271 6.07292 7.96562 6 7.75437 6C7.54312 6 7.36458 6.07146 7.21875 6.21437C7.07292 6.35729 7 6.53437 7 6.74562C7 6.95687 7.07146 7.13542 7.21438 7.28125C7.35729 7.42708 7.53438 7.5 7.74563 7.5C7.95688 7.5 8.13542 7.42854 8.28125 7.28563ZM12.7813 7.28563C12.9271 7.14271 13 6.96563 13 6.75438C13 6.54313 12.9285 6.36458 12.7856 6.21875C12.6427 6.07292 12.4656 6 12.2544 6C12.0431 6 11.8646 6.07146 11.7187 6.21437C11.5729 6.35729 11.5 6.53437 11.5 6.74562C11.5 6.95687 11.5715 7.13542 11.7144 7.28125C11.8573 7.42708 12.0344 7.5 12.2456 7.5C12.4569 7.5 12.6354 7.42854 12.7813 7.28563Z",
    fill: "#0A5040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile16);
export default __webpack_public_path__ + "static/media/profile-16.05df1138b31cc3946e212d535ca06953.svg";
export { ForwardRef as ReactComponent };